import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';

const ICON_SIZES = { sm: 15, lg: 19 };

function buttonClasses({ variant, size, block, iconOnly, className }) {
  return [
    'btn',
    `btn-${variant}`,
    size && `btn-${size}`,
    block && 'btn-block',
    iconOnly && 'btn-icon',
    className,
  ].filter(Boolean).join(' ');
}

function ButtonContent({ icon: Icon, iconRight: IconRight, loading, size, children }) {
  const iconSize = ICON_SIZES[size] || 17;
  return (
    <>
      {loading ? <span className="btn-spinner" aria-hidden="true" /> : Icon && <Icon size={iconSize} aria-hidden="true" />}
      {children}
      {IconRight && <IconRight size={iconSize} aria-hidden="true" />}
    </>
  );
}

// <Button variant="primary|accent|secondary|ghost|danger|success" size="sm|lg" icon={Plus} loading block>
// Icon-only buttons need an aria-label.
export const Button = forwardRef(function Button(
  { variant = 'secondary', size, icon, iconRight, loading = false, block = false, className, children, disabled, ...props },
  ref
) {
  return (
    <button
      ref={ref}
      type="button"
      {...props}
      disabled={disabled || loading}
      className={buttonClasses({ variant, size, block, iconOnly: !children, className })}
    >
      <ButtonContent icon={icon} iconRight={iconRight} loading={loading} size={size}>
        {children}
      </ButtonContent>
    </button>
  );
});

// A router link that looks like a button
export function ButtonLink({ to, variant = 'secondary', size, icon, iconRight, block = false, className, children, ...props }) {
  return (
    <Link to={to} {...props} className={buttonClasses({ variant, size, block, iconOnly: !children, className })}>
      <ButtonContent icon={icon} iconRight={iconRight} size={size}>
        {children}
      </ButtonContent>
    </Link>
  );
}
